<template>
  <div class="p-5">
    <b-row class="mt-4 pb-4">
      <b-col align-self="center">
        <h4>Zusätzliche Feiertage</h4>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />
    <u-loader v-if="isLoading" />
    <div
      v-else
      class="col-10"
    >
      <v-btn
        v-if="canUserEdit"
        class="float-right"
        color="success"
        flat
        title="Feiertag erfassen"
        @click="showModal('additionalHolidayCreate')"
      >
        <i class="fas fa-plus mr-3" /> Erfassen
      </v-btn>

      <table class="w-100 calenderOverview ml-2 mt-4">
        <thead>
          <tr>
            <th>Jahr</th>
            <th>Anzahl Tage</th>
            <th style="width: 80%">
              Örtliche Einschränkung
            </th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="additionalWorkday in additionalWorkdays"
            :key="additionalWorkday.id"
          >
            <td class="custom-td">
              {{ additionalWorkday.year }}
            </td>
            <td class="custom-td">
              {{ additionalWorkday.noDays }}
            </td>
            <td class="custom-td">
              <u-tree-view
                v-if="
                  additionalWorkday.additionalHolidayLocations &&
                    additionalWorkday.additionalHolidayLocations.length > 0
                "
                :disabled="true"
                :tree-view-items="locationOptions"
                :value="
                  getLocalisedPaths(
                    additionalWorkday.additionalHolidayLocations,
                  )
                "
                item-children="children"
                item-key="path"
              />
              <span v-else>Keine örtliche Einschränkung</span>
            </td>
            <td class="custom-td">
              <v-btn
                v-if="canUserEdit"
                class="pt-0"
                color="#007bff"
                dark
                fab
                small
                title="Bearbeiten"
                @click="
                  additionalWorkdayEdit = additionalWorkday;
                  showModal('additionalHolidayEdit');
                "
              >
                <i class="fas fa-edit" />
              </v-btn>
              <v-btn
                v-if="canUserEdit"
                color="#e72b37"
                dark
                fab
                small
                title="Löschen"
                @click="deleteAdditionalHoliday(additionalWorkday.id)"
              >
                <i class="fas fa-trash" />
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-dialog
      v-model="additionalHolidayCreateOpen"
      max-width="900"
    >
      <v-card>
        <v-card-title>
          <h5>Zusätzlicher Feiertag erfassen</h5>
        </v-card-title>
        <additional-holidays-create
          :localised-options="locationOptions"
          class="p-3"
          @canceled="hideModal('additionalHolidayCreate')"
          @saved="createAdditionalholiday"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="additionalHolidayEditOpen"
      max-width="900"
    >
      <v-card>
        <v-card-title>
          <h5>Zusätzlicher Feiertag bearbeiten</h5>
        </v-card-title>
        <additional-holidays-edit
          :additional-holiday-to-edit="additionalWorkdayEdit"
          :localised-options="locationOptions"
          class="p-3"
          @canceled="hideModal('additionalHolidayEdit')"
          @saved="createAdditionalholiday"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  DeleteAdditionalholidays,
  GetAdditionalholidays,
} from "@/services/minimum.wage.services/holidays.minimum.wages";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import UTreeView from "@/components/common/UTreeView.vue";
import AdditionalHolidaysCreate from "@/components/minimum.wage/pages/Holidays/Capture/AdditionalHolidays_Create.vue";
import AdditionalHolidaysEdit from "@/components/minimum.wage/pages/Holidays/Capture/AdditionalHolidays_Edit.vue";

export default {
  components: {
    AdditionalHolidaysEdit,
    AdditionalHolidaysCreate,
    UTreeView,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      isLoading: false,
      errorObject: "",
      workdays: {},
      workday: 0,
      hasConfig: false,
      additionalWorkdays: [],
      additionalWorkdayEdit: {},
      additionalHolidayCreateOpen: false,
      additionalHolidayEditOpen: false,
    };
  },
  computed: {
    locationOptions() {
      let locationsOfEdition =
        this.$store.state.mindestLohnKonfiguration.ValidEditionLocations;

      let citiesCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Cities),
      );
      let topLevel = [
        {
          name: "CH",
          path: "CH",
          children: [],
          shutoff: false,
        },
      ];
      const cantonIdMap = new Map();
      for (const item of citiesCopy) {
        if (!cantonIdMap.has(item.cantonId)) {
          cantonIdMap.set(item.cantonId, true);
          if (locationsOfEdition.some((x) => x.cantonId == item.cantonId)) {
            topLevel[0].children.push({
              id: item.cantonId,
              name: `${item.canton} (${item.cantonCode})`,
              path: `CH/${item.cantonCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      const districtCodeMap = new Map();
      for (const item of citiesCopy) {
        if (!districtCodeMap.has(item.districtCode)) {
          districtCodeMap.set(item.districtCode, true);
          let cantonOfDistrict = topLevel[0].children.find(
            (x) => x.path === `CH/${item.cantonCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId && x.districtId == item.districtId,
            )
          ) {
            cantonOfDistrict.children.push({
              id: item.districtId,
              name: item.district,
              districtCode: item.districtCode,
              path: `CH/${item.cantonCode}/${item.districtCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      citiesCopy.map((item) => {
        let cantonOfCity = topLevel[0].children.find(
          (x) => x.path === `CH/${item.cantonCode}`,
        );
        if (cantonOfCity) {
          let districtOfCity = cantonOfCity.children.find(
            (x) => x.path === `CH/${item.cantonCode}/${item.districtCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId &&
                x.districtId == item.districtId &&
                x.cityId == item.cityId,
            )
          ) {
            item.name = `${item.plz} ${item.city}`;
            item.id = item.cityId;
            item.path = `CH/${item.cantonCode}/${item.districtCode}/${
              item.onrp
            }`;
            item.shutoff = false;
            districtOfCity.children.push(item);
          }
        }
      });

      return topLevel;
    },
  },
  watch: {
    "$store.state.mindestLohnKonfiguration.Configuration.editionId":
      function () {
        this.$store.dispatch("getAllValidEditionLocations", {
          contractId: this.contractId,
          versionId: this.versionId,
          editionId:
            this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
        });
      },
  },
  created() {
    this.loadAdditionalholidays();
  },
  methods: {
    deleteAdditionalHoliday(id) {
      this.isLoading = true;
      DeleteAdditionalholidays(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        id,
        () => {
          this.loadAdditionalholidays();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createAdditionalholiday() {
      this.hideModal("additionalHolidayCreate");
      this.hideModal("additionalHolidayEdit");
      this.loadAdditionalholidays();
    },
    loadAdditionalholidays() {
      this.isLoading = true;
      GetAdditionalholidays(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        (response) => {
          this.additionalWorkdays = response;

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getLocalisedPaths(locations) {
      return locations.map((location) => location.path);
    },
    hideModal(modalId) {
      this[`${modalId}Open`] = false;
    },
    showModal(modalId) {
      this[`${modalId}Open`] = true;
    },
  },
};
</script>

<style scoped>
.custom-td {
  vertical-align: top;
}

.calenderOverview {
  font-size: small;
  table-layout: fixed;
}

.calenderOverview thead th:nth-child(1) {
  width: 20%;
}

.calenderOverview thead th:nth-child(2) {
  width: 20%;
}

.calenderOverview thead th:nth-child(3) {
  width: 20%;
}

.calenderOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.calenderOverview td,
.calenderOverview th {
  padding: 8px 4px;
}
</style>
